"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTelPrefix = void 0;
var base_1 = require("./base");
// 根据国家码查询国家电话码（input：[字符串]国家码， output：电话前缀）
var getTelPrefix = function (countryCode) {
    var result = (0, base_1.getPhoneList)().filter(function (item) {
        return item[countryCode];
    });
    return result.length ? result[0][countryCode] : '';
};
exports.getTelPrefix = getTelPrefix;
